/*
 *  Author: DL
 *  Date: 2020-12-04 17:07:19
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-12 20:45:04
 *  LastEditors: DL
 *  Description: 快捷方式
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React, { useState } from 'react';
import classnames from 'classnames';
import settingConfig from 'config/setting';
import styles from './index.less';

const { shortcut: res } = settingConfig;

export default props => {
    const { data = res, onClick, collapsible } = props;

    const [shortcut, setShortcut] = useState(-1);

    const handleClick = event => {
        event.persist();
        const target = event.currentTarget;

        const value = target.dataset.value;
        setShortcut(value);

        if (onClick) {
            onClick(value);
        }
    };

    const wrapper = classnames({
        [`${styles.warrap}`]: true,
        [`${styles.collapsible}`]: collapsible,
    });

    return (
        <ul className={wrapper}>
            {data.map(({ typeID, name }) => (
                <li key={typeID} data-value={name} onClick={handleClick} className={classnames({ [`${styles.active}`]: typeID === shortcut })}>
                    {name}
                </li>
            ))}
        </ul>
    );
};
